import api from './api';

const authService = {
  /**
   * Login user
   * @param {string} email 
   * @param {string} password 
   * @returns {Promise} User data and token
   */
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },

  /**
   * Logout user
   * @returns {Promise}
   */
  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      // Ignore errors on logout
      console.error('Logout error:', error);
    }
  },

  /**
   * Verify token
   * @returns {Promise} User data
   */
  verifyToken: async () => {
    const response = await api.post('/auth/verify-token');
    return response.data;
  },

  /**
   * Request password reset
   * @param {string} email 
   * @returns {Promise}
   */
  requestPasswordReset: async (email) => {
    const response = await api.post('/auth/reset-password', { email });
    return response.data;
  },

  /**
   * Confirm password reset
   * @param {string} token 
   * @param {string} newPassword 
   * @returns {Promise}
   */
  confirmPasswordReset: async (token, newPassword) => {
    const response = await api.post('/auth/reset-password/confirm', {
      token,
      newPassword
    });
    return response.data;
  }
};

export default authService;
